import { useRef } from 'react';
import { LoadScript, GoogleMap, Marker } from '@react-google-maps/api';
import { useStoreState } from 'pullstate';
import StepLayout from './StepLayout';
import activeLogo from '../../../images/ActiveFlameLogo.png';
import { modalToggleStore, coordsStore, profileFormStore } from '../../../store/Store';

const ApplyPermit5 = () => {
    const currentBurnCoord = coordsStore.useState((s) => s.currentBurnCoord);
    const { mapsAPI } = useStoreState(profileFormStore);
    const mapRef = useRef(null);

    const onMapLoad = (map) => {
        mapRef.current = map;
    };

    const handleCenterAndBurnCoord = (e) => {
        const burnCoord = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
        };
        coordsStore.update((s) => {
            s.currentBurnCoord = burnCoord;
            s.mapCenterCoord = burnCoord;
        });
    };

    const handleCenter = () => {
        if (!mapRef.current) return;
        const center = mapRef.current.getCenter();
        coordsStore.update((s) => {
            s.mapCenterCoord = { lat: center.lat(), lng: center.lng() };
        });
    };

    const openSixthPage = () => {
        modalToggleStore.update((s) => {
            s.permitPage = 6;
        });
    };

    return (
        <StepLayout
            title='Confirm your burn location'
            primaryLabel='Continue'
            onPrimary={openSixthPage}
        >
            <p>
                It's important to know where the burn will take place on your property. Please tap
                or click on the map to reposition the flame to indicate where you will conduct the
                burn.
            </p>
            <div
                className='flow-map'
                role='region'
                aria-label='Satellite map of your property. The flame marker shows the burn location.'
            >
                {mapsAPI && currentBurnCoord && (
                    <LoadScript
                        id='script-loader'
                        googleMapsApiKey={`${mapsAPI}&libraries=drawing,places`}
                        language='en'
                        region='us'
                    >
                        <GoogleMap
                            mapContainerClassName='flow-map__canvas'
                            zoom={18}
                            mapTypeId='satellite'
                            onLoad={onMapLoad}
                            onDragEnd={handleCenter}
                            onClick={handleCenterAndBurnCoord}
                            center={currentBurnCoord}
                        >
                            <Marker icon={activeLogo} position={currentBurnCoord} title='Burn location' />
                        </GoogleMap>
                    </LoadScript>
                )}
            </div>
            <p className='flow-step__muted'>
                The flame starts at your address, so if you can't use the map you can continue as
                is.
            </p>
        </StepLayout>
    );
};

export default ApplyPermit5;
